import React, { Component } from 'react';
import Select from 'react-select';
import Firebase from 'firebase';



export default class MultiSelectFieldStores extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.stores,
            options: {},
            stores_users: []

        }
        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    componentWillMount() {
        var storesRef = Firebase.database().ref('stores')
            .child(localStorage.client_id)
            .once('value')
            .then(resp => {
                this.setState({ stores: resp.val() });
                this.setOptions(resp.val());
            });
    }

    setOptions(stores) {
        var options = [];
        var arrayStores = this.state.stores;
        Object.keys(stores).map((m, index) => {
            var value = {
                label: Object.values(Object.values(stores)[index])[1],
                value:  Object.values(Object.values(stores)[index])[0]
            }
            options.push(value);
        });
        this.setState({ options: options });
    }

    handleSelectChange(value) {
        this.setState({ value });
        var array = value.split(',');
        this.props.callBack(array);
    }

    render() {
        return (
            <div className="section">
                <Select multi simpleValue value={this.state.value} placeholder="Seleccione locales asignados" options={Object.values(this.state.options)} onChange={this.handleSelectChange} />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/users/MultiSelectFieldStores.js